export default __webpack_public_path__ + "static/media/pop_logo_zh-TW.f5a5a928.png";